<template>
  <div>
    <img :src=svg height="43" alt="">
  </div>
</template>

<script>
// import Filter from './components/Filter.vue'
// import Vue from 'vue';
// 『イベントバス』のためのインスタンス
// var bus = new Vue();

export default {
  name: 'Qnumber',
  data () {
    return {
      // msg: 'Hello Vue Component',
    }
  },
  computed : {
    svg : function(){
      var linkId = this.$store.state.userSelect.link;
      var cq = this.$store.state.question.filter(function(item) {
        // console.log(item.id);
        return item.id === linkId;
      })[0];
      return './share/images/shindan_q' + cq.num + '.svg';
      // return './share/images/shindan_q'+this.$store.state.userSelect.currentQnum+'.svg';
    }
  },

  // // watch: {
  // //   mat: function (newValue, oldValue) {
  // //     console.log(newValue, oldValue);
  // //   },
  // // },

  // methods: {
  //     click: function(){
  //         this.$emit('child-event', this.hee);//親へイベント発火を伝える

  //         this.$store.commit('setMat', this.mat);
  //         this.$store.commit('setWid', this.wid);
  //         this.$store.commit('setCol', this.col);
  //         this.$store.commit('setDes', this.des);
  //         this.$store.commit('setHee', this.hee);
  //         // bus.$emit('bus-event', this.hee);
  //     },
  //     resetAll: function(){
  //         this.$store.commit('setMat', []);
  //         this.$store.commit('setWid', []);
  //         this.$store.commit('setCol', []);
  //         this.$store.commit('setDes', []);
  //         this.$store.commit('setHee', []);
  //     }
  // }
}
</script>

<style>
</style>
